// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1p7Qt","label":"Category_label__2Ci5O","content":"Category_content__30Hzg","header":"Category_header__2xR3H","location":"Category_location__2qxL4"};